// src/pages/MPFlow/components/targeting/GenderSelector.jsx
import React from 'react';

const OPTIONS = [
  { value: 'all',    label: 'Todos',   icon: '👥' },
  { value: 'male',   label: 'Homens',  icon: '♂️' },
  { value: 'female', label: 'Mulheres', icon: '♀️' },
];

export default function GenderSelector({ value = 'all', onChange }) {
  return (
    <div className="seg-gender">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`seg-gender__btn ${value === opt.value ? 'seg-gender__btn--active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          <span className="seg-gender__icon">{opt.icon}</span>
          <span>{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
